module.exports = __webpack_public_path__ + "img/Wix_menu_drop.731840fc.jpg";